<template>
  <div class="article-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="我的收藏" :showBack="true"></my-header>
    <div class="general-tab-part favorite-tab" style="display: flex;justify-content: space-between;">
      <div class="tab-item" @click = "change('5')" :class="{'item-one':type == '5'}">全屋记</div>
      <div class="tab-item" @click = "change('2')" :class="{'selected':type == '2'}">文章</div>
      <div class="tab-item" @click = "change('3')" :class="{'selected':type == '3'}">图片</div>
      <div class="tab-item" @click = "change('4')" :class="{'selected':type == '4'}">问答</div>
      <div class="tab-item" @click = "change('1')" :class="{'selected':type == '1'}">商品</div>
    </div>
    <!--<mt-loadmore  style="overflow-y: scroll" :autoFill="autoFill" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore">-->
    <div v-if="type == '1'" class="product-list">
      <div v-for="product in favoriteList" class="product-item" @click="toProductDetail(product.id)">
        <img class="product-image" :src="product.image">
        <div class="product-name">{{product.name}}</div>
        <div class="product-box">
          <div class="product-sku"><span>￥</span><span class="price">{{product.price}}</span><span>/{{product.unit}}</span></div>
          <img class="product-collect" src="../../assets/icon/icon-star-on.png">
        </div>
      </div>
    </div>
    <div v-if="type == '2'" class="shop-list">
      <div class="shop-item general-box-shadow" v-for="shop in favoriteList" @click="toShopDetail(shop.id)">
        <img class="shop-logo" :src="shop.logo">
        <div>
         <div class="shop-name">{{shop.name}}</div>
         <div class="shop-info">
           <div class="shop-trade-info">订单数 <span>{{shop.orderNum}}</span> </div>
           <div class="shop-trade-info">交易数 <span>{{shop.sales}}</span></div>
         </div>
      </div>
      </div>
    </div>
    <div v-if="type == '3'" class="product-list">
      <!-- <div @click="toArticleDetail(article.id,article.title)">
        <img v-if="article.cover" class="article-cover" :src="article.cover">
        <img v-else="" class="article-cover" src="../../assets/icon/icon-favorite-article-cover.png">
        <div>
          <div class="article-title">{{article.title}}</div>
          <div class="article-summary">{{article.summary}}</div>
        </div>
      </div> -->
      <div v-for="article in favoriteList" class="product-item" @click="toArticleDetail(article.id,article.title)">
        <img v-if="article.cover"  class="product-image" :src="article.cover">
        <img v-else="" class="product-image" src="../../assets/icon/icon-favorite-article-cover.png">
        <div class="product-name">{{article.title}}</div>
        <div class="product-sku" style="color:black;">{{article.summary}}</div>
      </div>
    </div>
    <div v-if="type == '4'" class="favorite-article question-item" v-for="question in favoriteList" @click="toQuestionDetail(question.id,article.title)">
      <img v-if="question.images" :src="question.images">
      <div>
        <div class="article-title">{{question.subject}}</div>
        <div class="article-summary">{{question.content}}</div>
      </div>
    </div>
    <div class="black-page" v-if="favoriteList.length==0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">您暂未收藏过内容</div>
    </div>
    <!--</mt-loadmore>-->
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl} from "../../config";
  import customerFavoriteList from '../../service/customer/FavoriteService'

  export default {
    name: 'CustomerFavoriteList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        favoriteList:[],
        allLoaded: false,
        pageNo:1,
        autoFill:false,
        isShowSearch:false,
        showCancel:true,
        type:'2',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if (this.global.type) {
        this.type = this.global.type;
        this.global.type = '';
      }
      this.change(this.type);
    },
    methods: {
      change(type){
        this.type = type;
        this.loadFavoriteList();
      },
      async loadFavoriteList(onCancel = function(){}){
        if(this.pageNo == 1){
          this.favoriteList = [];
        }
        let {code,msg,data} = await customerFavoriteList.list(this.type,this.pageNo);
        if(code == '0'){
          for(let item of data){
            if(this.type == '3' && item.title.length>21){
              item.title = item.title.substring(0,21)+'...'
            }
            if(this.type == '3' && item.cover){
              item.cover = this.imgUrl + item.cover;
            }
            if(this.type == '4' && item.images){
              item.images = this.imgUrl + item.images.substring(0,36);
            }
            if(this.type == '1' && item.name.length>8){
              item.name = item.name.substring(0,8)+'...';
            }
            if(this.type == '3' && !item.cover){
              var contentImgArray = item.content.match(/<img[^>]+>/g);
              if(contentImgArray && contentImgArray.length>0){
                let srcWithQuotes = contentImgArray[0].match(/src=('|")?([^'"]+)/)[2];
                item.cover = srcWithQuotes;
              }
            }
            this.favoriteList.push(item)
          }
          this.allLoaded = !data.length || data.length < 5;
          onCancel();
        }else {
          Toast(msg);
        }
      },
      loadBottom(){
        this.pageNo++;
        this.loadArticleList(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
      //跳转店铺详情
      toShopDetail(id){
        if(!!this.global.isMiniProgrm){
          wx.miniProgram.navigateTo({url: '/pages/shop/detail/detail?shopId='+id});
        }else {
          this.global.type = this.type;
          this.$router.push({name: 'ShopDetail', query: {shopId:id}})
        }
      },
      //跳转商品详情
      toProductDetail(productId,shopId){
        if(!!this.global.isMiniProgrm){
          wx.miniProgram.navigateTo({url: '/pages/product/detail/detail?productId='+id});
        }else {
          this.global.type = this.type;
          this.$router.push({name: 'ProductDetail', query: {productId,shopId}})
        }
      },
      //跳转图片详情
      toArticleDetail(id,title){
        if(!!this.global.isMiniProgrm){
          wx.miniProgram.navigateTo({url: '/pages/article/detail/detail?articleId='+id+"&original=favorite"});
        }else {
          this.global.type = this.type;
          this.$router.push({name: 'ArticleDetail', query: {articleId:id,title}})
        }

      },
      //跳转店铺列表页
      toShopList(){
        this.global.type = this.type;
        this.$router.push({name: 'ShopList'});
      },
      toArticleList(){
        this.global.type = this.type;
        this.$router.push({name:'ArticleList'});
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .article-list-page{
    text-align: left;
    padding-bottom: 0.5rem;
    font-size: 0.3rem;
    background-color: white;
    .favorite-tab{
      font-size: 0.32rem;
      .tab-item{
        margin-left: 0.24rem;
      }
      .item-one{
        position: relative;
        font-size: 0.36rem;
      }
      .item-one:after{
        content: '';
        position: absolute;
        top: 0.8rem;
        left: 20%;
        bottom: 0;
        right: 0;
        width: 0.5rem;
        height: 0.08rem;
        background-color: #333;
        text-align: center;
      }
      .selected{
        position: relative;
        font-size: 0.36rem;
      }
      .selected:after {
      content: '';
      position: absolute;
      top: 0.8rem;
      left: 8%;
      bottom: 0;
      right: 0;
      width: 0.5rem;
      height: 0.08rem;
      background-color: #333;
      text-align: center;
    }
    }
    .shop-list{
      padding: 0 0.3rem;
      height: 100%;
      overflow-y: scroll;
      flex-grow: 1;
      flex-wrap: nowrap;
      .shop-item{
        width: 6.9rem;
	      height: 1.71rem;
        position: relative;
        display: flex;
        margin-top: 0.1rem;
        margin-bottom: 0.2rem;
        .shop-logo{
          width: 1.3rem;
          height: 1.3rem;
          margin: 0.2rem 0 0.2rem 0.2rem;
          border-radius: 6px;
        }
        .shop-name{
          font-size: 0.36rem;
          margin-top: 0.3rem;
          margin-left: 0.3rem;
          padding-bottom: 0.2rem;
        }
        .shop-info{
          display: flex;
          padding-left: 0.28rem;
          .shop-trade-info{
            width: 2rem;
          	height: 0.4rem;
            background-color: #e0dedc;
            font-size: 0.24rem;
            border-radius: 20px;
            margin-right: 0.2rem;
            text-align: center;
            line-height: 0.44rem;
          }
          .shop-trade-info span{
            font-size: 0.26rem;
          }
        }
      }
    }
  .product-list{
    padding-bottom: 1rem;
    display: flex;
    flex-flow: row wrap;
    .product-item{
      width: 3.3rem;
      margin-left: 0.3rem;
      background-color: white;
      margin-bottom: 0.3rem;
      .product-collect{
        margin-top: 0.26rem;
        margin-right: 0.1rem;
        width: 0.3rem;
        height: 0.3rem;
      }
      .product-box{
        display: flex;
        justify-content: space-between;
      }
      .product-image{
        width: 3.3rem;
        height: 3.3rem;
        border-radius: 0.1rem;
      	border: solid 1px #eee;
      }
      .product-name{
        margin-top: 0.18rem;
        line-height: 0.3rem;
        font-size: 0.3rem;
      }
      .product-sku{
        margin-top: 0.2rem;
        color: #e07070;
        font-size: 0.26rem;
        .price{
          margin-left: 0.1rem;
          margin-right: 0.07rem;
          font-size: 0.34rem;
          font-weight: bold;
        }
      }
    }
  }
    .favorite-article{
      display: flex;
      justify-content: space-between;
      width: 6.9rem;
      margin: 0 auto 0.4rem;
      .article-cover{
        display: block;
        width: 2.9rem;
        height: 2rem;
        margin-right: 0.3rem;
        border-radius: 0.1rem;
      }
      .article-title{
        width: 2.9rem;
        margin-bottom: 0.2rem;
        font-weight: bold;
      }
      .article-summary{
        font-size: 0.26rem;
        width: 2.9rem;
        color: #666;
      }
    }
    .question-item{
      width: 6.2rem;
      padding: 0.3rem 0.3rem 0.24rem 0.3rem;
      border: solid 1px #eee;
      border-radius: 0.1rem;
      img{
        width: 2.3rem;
        height: 2rem;
        display: block;
        margin-right: 0.3rem;
        border-radius: 0.1rem;
      }
    }
  }
</style>
